import { Resource } from "../../types/entity";

const validateEmailResource = (resource: null | Resource | undefined) => {
  const notFound = !resource?.file;
  const restricted = resource?.isPublic === false;
  const valid = !notFound && !restricted;

  return { notFound, restricted, valid };
};

export default validateEmailResource;
